/**
 * Hand-authored OpenAPI-style client for delivery-retry APIs (RBA-2722).
 * Prefer regenerating from swagger when official generate covers this controller.
 */
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface DeliveryRetryConfigVO {
  id?: number;
  retryDelayMinutes?: number;
  enabled?: boolean;
}

export interface DeliveryRetryConfigDTO {
  id?: number;
  retryDelayMinutes: number;
  enabled?: boolean;
}

export interface LogisticsCreateDTO {
  accountId: number;
  serviceCode: string;
  deliveryNote?: string;
  codAmount?: number;
  length: number;
  width: number;
  height: number;
  weight: number;
}

@Injectable({ providedIn: 'root' })
export class DeliveryRetryApiService {
  private readonly http = inject(HttpClient);
  private readonly basePath = environment.orderServiceBasePath;

  getConfig(): Observable<DeliveryRetryConfigVO> {
    return this.http.get<DeliveryRetryConfigVO>(
      `${this.basePath}/v1/delivery-retry/config`,
    );
  }

  updateConfig(body: DeliveryRetryConfigDTO): Observable<DeliveryRetryConfigVO> {
    return this.http.put<DeliveryRetryConfigVO>(
      `${this.basePath}/v1/delivery-retry/config`,
      body,
    );
  }

  retryDelivery(
    orderId: number,
    body?: LogisticsCreateDTO,
  ): Observable<unknown> {
    return this.http.post(
      `${this.basePath}/v1/delivery-retry/orders/${orderId}/retry`,
      body ?? null,
    );
  }

  returnStock(orderId: number, note?: string): Observable<string> {
    return this.http.post(
      `${this.basePath}/v1/delivery-retry/orders/${orderId}/return-stock`,
      note ? { note } : {},
      { responseType: 'text' },
    );
  }

  markDeliveryFailed(orderId: number, note?: string): Observable<void> {
    return this.http.post<void>(
      `${this.basePath}/v1/delivery-retry/orders/${orderId}/mark-failed`,
      note ? { note } : {},
    );
  }
}
